  // All CSS Styles
import React, { useState, useEffect } from 'react';
import ContactPage from './Contact';
import MembershipPage from './Member';
import EventsPage from './Event';
import ArticlesPage from './Article';
import AboutPage from './About';
import ServicesPage from './Services';
import FooterPage from './Footer';
import NotificationContainer from './notification';

const Landing = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [articles, setArticles] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // API base URL - adjust for your deployment
  const API_BASE = '/api';

      // Notification system
    const showNotification = (message, type = 'success') => {
        const id = Date.now();
        const notification = { id, message, type };
        setNotifications(prev => [...prev, notification]);
        
        // Auto remove after 5 seconds
        setTimeout(() => {
            setNotifications(prev => prev.filter(n => n.id !== id));
        }, 5000);
    };

    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    };


  // Fetch articles from API
  const fetchArticles = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE}/articles`);
      const data = await response.json();
      setArticles(data);
    } catch (error) {
      console.error('Error fetching articles:', error);
      showNotification('Error loading articles', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Submit contact form

  const fetchEvents = async () => {
      try {
          setLoading(true);
          const response = await fetch(`${API_BASE}/events`);
          const data = await response.json();
          setEvents(data);
      } catch (error) {
          console.error('Error fetching events:', error);
          showNotification('Error loading events', 'error');
      } finally {
          setLoading(false);
      }
  };

  // Load data when component mounts
  useEffect(() => {
    fetchArticles();
    fetchEvents();
  }, []);

  // Sample stats - in production, fetch from API
  const stats = [
    { number: "500+", label: "Active Members" },
    { number: "10+", label: "Partner Companies" },
    { number: "5+", label: "Annual Events" },
    // { number: "$2.5B+", label: "Deals Facilitated" }
  ];

  // Navigation Component
  const Navigation = () => (
    <nav style={navStyles}>
      <div style={navContainerStyles}>
      <div style={logoStyles}>
          <img 
            src="/sbn-logo.png"
            alt="Saudi British Network Logo"
            style={logoImageStyles}
          />
          <h2 style={logoTextStyles}>Saudi British Network</h2>
        </div>
        <ul style={navLinksStyles}>
          <li>
            <a 
              href="#home" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('home'); }}
              style={{...navLinkStyles, ...(currentPage === 'home' ? navLinkActiveStyles : {})}}
            >
              Home
            </a>
          </li>
          <li>
            <a 
              href="#about" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('about'); }}
              style={{...navLinkStyles, ...(currentPage === 'about' ? navLinkActiveStyles : {})}}
            >
              About
            </a>
          </li>
          <li>
            <a 
              href="#service" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('service'); }}
              style={{...navLinkStyles, ...(currentPage === 'service' ? navLinkActiveStyles : {})}}
            >
              Services
            </a>
          </li>
          <li>
            <a 
              href="#articles" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('articles'); }}
              style={{...navLinkStyles, ...(currentPage === 'articles' ? navLinkActiveStyles : {})}}
            >
              Articles & Insights
            </a>
          </li>
          <li>
            <a 
              href="#events" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('events'); }}
              style={{...navLinkStyles, ...(currentPage === 'events' ? navLinkActiveStyles : {})}}
            >
              Events
            </a>
          </li>
          <li>
            <a 
              href="#membership" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('membership'); }}
              style={{...navLinkStyles, ...(currentPage === 'membership' ? navLinkActiveStyles : {})}}
            >
              Membership
            </a>
          </li>
          <li>
            <a 
              href="#contact" 
              onClick={(e) => { e.preventDefault(); setCurrentPage('contact'); }}
              style={{...navLinkStyles, ...(currentPage === 'contact' ? navLinkActiveStyles : {})}}
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );

  // Home Page Component
  const HomePage = () => (
    <div>
      {/* Hero Section */}
      <section style={heroStyles}>
        <div style={heroOverlayStyles}>
          <div style={containerStyles}>
            <div style={heroContentStyles}>
              <h1 style={heroTitleStyles}>
                Connecting Saudi Arabia & United Kingdom
              </h1>
              <p style={heroSubtitleStyles}>
                Building bridges between two nations through business, innovation, and cultural exchange. 
                Join the premier network for Saudi-British professionals and entrepreneurs.
              </p>
              <div style={heroButtonsStyles}>
                <button 
                  style={primaryButtonStyles}
                  onClick={() => setCurrentPage('membership')}
                >
                  Join Network
                </button>
                <button 
                  style={secondaryButtonStyles}
                  onClick={() => setCurrentPage('events')}
                >
                  Explore Events
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={statsSection}>
        <div style={containerStyles}>
          <div style={statsGridStyles}>
            {stats.map((stat, index) => (
              <div key={index} style={statItemStyles}>
                <h3 style={statNumberStyles}>{stat.number}</h3>
                <p style={statLabelStyles}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          <div style={aboutGridStyles}>
            <div style={aboutTextStyles}>
              <h2 style={sectionTitleStyles}>Strengthening Saudi-British Relations</h2>
              <p style={aboutDescStyles}>
                The Saudi British Network serves as the premier platform for fostering business relationships, 
                cultural understanding, and economic cooperation between Saudi Arabia and the United Kingdom.
              </p>
              <p style={aboutDescStyles}>
                Our community includes entrepreneurs, executives, investors, government officials, and professionals 
                who are passionate about building bridges between these two dynamic economies.
              </p>
            </div>
            <div style={aboutImageStyles}>
              <img 
                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Business meeting" 
                style={imageStyles}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section style={{...sectionStyles, backgroundColor: '#f8f9fa'}}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Latest Insights</h2>
          {loading ? (
            <div style={loadingStyles}>Loading articles...</div>
          ) : (
            <div style={articlesGridStyles}>
              {articles.slice(0, 3).map(article => (
                <div key={article.id} style={articleCardStyles}>
                  <img 
                    src={article.image_url || 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'} 
                    alt={article.title} 
                    style={articleImageStyles} 
                  />
                  <div style={articleContentStyles}>
                    <span style={categoryBadgeStyles}>{article.category}</span>
                    <h3 style={articleTitleStyles}>{article.title}</h3>
                    <p style={articleExcerptStyles}>{article.excerpt}</p>
                    <div style={articleMetaStyles}>
                      <span>{article.author}</span>
                      <span>{new Date(article.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div style={centerStyles}>
            <button 
              onClick={() => setCurrentPage('articles')}
              style={primaryButtonStyles}
            >
              View All Articles
            </button>
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Upcoming Events</h2>
          {loading ? (
            <div style={loadingStyles}>Loading events...</div>
          ) : (
            <div style={eventsGridStyles}>
              {events.slice(0, 2).map(event => (
                <div key={event.id} style={eventCardStyles}>
                  <img 
                    src={event.image_url || 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'} 
                    alt={event.title} 
                    style={eventImageStyles} 
                  />
                  <div style={eventContentStyles}>
                    <div style={eventTypeStyles}>{event.event_type}</div>
                    <h3 style={eventTitleStyles}>{event.title}</h3>
                    <div style={eventDetailsStyles}>
                      <p><strong>Date:</strong> {event.date}</p>
                      <p><strong>Time:</strong> {event.time}</p>
                      <p><strong>Location:</strong> {event.location}</p>
                      <p><strong>Price:</strong> {event.price}</p>
                    </div>
                    <p style={eventDescStyles}>{event.description}</p>
                    {/* <button style={primaryButtonStyles}>Register Now</button> */}
                  </div>
                </div>
              ))}
            </div>
          )}
          <div style={centerStyles}>
            <button 
              onClick={() => setCurrentPage('events')}
              style={secondaryButtonStyles}
            >
              View All Events
            </button>
          </div>
        </div>
      </section>
    </div>
  );

  const logoImageStyles = {
  height: '40px',
  width: 'auto',
  marginRight: '12px',
  objectFit: 'contain'
};

const logoTextStyles = {
  margin: 0,
  color: '#006C35'
};

  const navStyles = {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e9ecef',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };

  const navContainerStyles = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem 2rem'
  };

  const logoStyles = {
      display: 'flex',
  alignItems: 'center',
  color: '#006C35'
  };

  const navLinksStyles = {
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    gap: '2rem'
  };

  const navLinkStyles = {
    textDecoration: 'none',
    color: '#333',
    fontWeight: '500',
    transition: 'color 0.3s ease'
  };

  const navLinkActiveStyles = {
    color: '#006C35',
    borderBottom: '2px solid #006C35',
    paddingBottom: '4px'
  };

  const heroStyles = {
    height: '100vh',
    backgroundImage: 'linear-gradient(135deg, rgba(0, 108, 53, 0.8), rgba(196, 30, 58, 0.8)), url("https://images.unsplash.com/photo-1586724237569-f3d0c1dee8c6?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  };

  const heroOverlayStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center'
  };

  const containerStyles = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
    width: '100%'
  };

  const heroContentStyles = {
    color: 'white',
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto'
  };

  const heroTitleStyles = {
    fontSize: '3.5rem',
    fontWeight: '700',
    marginBottom: '1.5rem',
    lineHeight: '1.2'
  };

  const heroSubtitleStyles = {
    fontSize: '1.3rem',
    marginBottom: '2.5rem',
    opacity: '0.95',
    lineHeight: '1.6'
  };

  const heroButtonsStyles = {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    flexWrap: 'wrap'
  };

const primaryButtonStyles = {
    backgroundColor: '#006C35',
    color: 'white',
    border: 'none',
    padding: '1rem 2rem',
    borderRadius: '50px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
};

  const secondaryButtonStyles = {
    backgroundColor: 'transparent',
    color: 'white',
    border: '2px solid white',
    padding: '1rem 2rem',
    borderRadius: '50px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  };

  const statsSection = { backgroundColor: '#f8f9fa', padding: '4rem 0' };
  const statsGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', textAlign: 'center' };
  const statItemStyles = { backgroundColor: 'white', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' };
  const statNumberStyles = { fontSize: '2.5rem', fontWeight: '700', color: '#006C35', marginBottom: '0.5rem' };
  const statLabelStyles = { color: '#666', fontSize: '1.1rem' };
  const sectionStyles = { padding: '5rem 0' };
  const sectionTitleStyles = { fontSize: '2.5rem', fontWeight: '700', textAlign: 'center', marginBottom: '3rem', color: '#333' };
  const aboutGridStyles = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center' };
  const aboutTextStyles = {};
  const aboutDescStyles = { fontSize: '1.1rem', lineHeight: '1.7', marginBottom: '1.5rem', color: '#666' };
  const aboutImageStyles = {};
  const imageStyles = { width: '100%', height: '400px', objectFit: 'cover', borderRadius: '10px' };
  const centerStyles = { textAlign: 'center' };
  const pageHeaderStyles = { backgroundColor: '#006C35', color: 'white', padding: '8rem 0 4rem 0', textAlign: 'center' };
  const pageHeaderTitleStyles = { fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' };
  const pageHeaderSubStyles = { fontSize: '1.2rem', opacity: '0.9', maxWidth: '600px', margin: '0 auto' };
  const loadingStyles = { textAlign: 'center', padding: '2rem', fontSize: '1.1rem', color: '#666' };
  const articlesGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem', marginBottom: '3rem' };
  const articleCardStyles = { backgroundColor: 'white', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', transition: 'transform 0.3s ease' };
  const articleImageStyles = { width: '100%', height: '200px', objectFit: 'cover' };
  const articleContentStyles = { padding: '2rem' };
  const categoryBadgeStyles = { backgroundColor: '#C41E3A', color: 'white', padding: '0.3rem 0.8rem', borderRadius: '15px', fontSize: '0.85rem', fontWeight: '600' };
  const articleTitleStyles = { fontSize: '1.3rem', fontWeight: '700', margin: '1rem 0', color: '#333' };
  const articleExcerptStyles = { color: '#666', lineHeight: '1.6', marginBottom: '1.5rem' };
  const articleMetaStyles = { display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#999' };
  const readMoreButtonStyles = { backgroundColor: 'transparent', color: '#006C35', border: '2px solid #006C35', padding: '0.5rem 1.5rem', borderRadius: '25px', fontSize: '0.9rem', fontWeight: '600', cursor: 'pointer', transition: 'all 0.3s ease', marginTop: '1rem' };
  const eventsGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '2rem', marginBottom: '3rem' };
  const eventCardStyles = { backgroundColor: 'white', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' };
  const eventImageStyles = { width: '100%', height: '200px', objectFit: 'cover' };
  const eventContentStyles = { padding: '2rem' };
  const eventTypeStyles = { backgroundColor: '#006C35', color: 'white', padding: '0.3rem 0.8rem', borderRadius: '15px', fontSize: '0.85rem', fontWeight: '600', display: 'inline-block', marginBottom: '1rem' };
  const eventTitleStyles = { fontSize: '1.3rem', fontWeight: '700', marginBottom: '1rem', color: '#333' };
  const eventDetailsStyles = { marginBottom: '1rem' };
  const eventDescStyles = { color: '#666', lineHeight: '1.6', marginBottom: '1.5rem' };


  // Render appropriate page based on currentPage state
  const renderPage = () => {
    switch(currentPage) {
      case 'home':
        return <HomePage />;
      case 'articles':
        return <ArticlesPage showNotification={showNotification} />;
      case 'events':
        return <EventsPage showNotification={showNotification} />;
      case 'membership':
        return <MembershipPage showNotification={showNotification} />;
      case 'contact':
        return <ContactPage showNotification={showNotification} />;
      case 'about':
        return <AboutPage />;
      case 'service':
        return <ServicesPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <style>
        {`
          @keyframes slideIn {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
        `}
      </style>
      
      <Navigation />
      <NotificationContainer removeNotification={removeNotification} notifications={notifications} />
      
      <div style={{ marginTop: '80px' }}>
        {renderPage()}
      </div>

      <FooterPage currentPage={currentPage} />
      
    </div>
  );
};

export default Landing;